<template>
  <div class="sign-up-container">
    <div class="navbar">
      <NavBar></NavBar>
    </div>
    <div class="sign-up-form">
      <!-- <img class="logo" src="../assets/stockantsLogo.png" alt="Organization Logo" /> -->

      <div class="signin-heading">
        Create Broker Account
      </div>

      <div class="input-group">
        <label>FULL NAME</label>
        <input type="text" v-model="form.full_name" />
      </div>

      <div class="input-group">
        <label>EMAIL ADDRESS</label>
        <input type="email" autocomplete="new-email" v-model="form.email_id" />
      </div>

      <div class="input-group">
        <label>MOBILE NUMBER</label>
        <input type="tel" v-model="form.mobile" maxlength="10" inputmode="numeric" @input="onMobileInput" />
      </div>

      <div class="input-group" style="position: relative;">
        <label>PASSWORD</label>
        <input :type="showPassword ? 'text' : 'password'" v-model="form.password" autocomplete="new-password"
          class="password-input" />
        <img v-if="showPassword" src="../assets/images/visibility.png" class="password-visibility"
          @click="togglePasswordVisibility" />
        <img v-else src="../assets/images/eye.png" class="password-visibility" @click="togglePasswordVisibility" />
      </div>

      <div class="input-group">
        <label>BROKER</label>
        <select v-model="form.broker_id">
          <option disabled value="">Select Broker</option>
          <option v-for="broker in brokerList" :key="broker.id" :value="broker.id">
            {{ broker.title }}
          </option>
        </select>
      </div>

      <div class="input-group">
        <label>ROLE</label>
        <select v-model="form.role">
          <option disabled value="">Select Role</option>
          <option value="Broker Admin">Broker Admin</option>
          <option value="Broker Associate">Broker Associate</option>
        </select>
      </div>

      <button class="signin-button" :disabled="isSubmitting" @click="createBrokerAdmin">
        <i v-if="isSubmitting" class="el-icon-loading" style="margin-right: 5px;"></i>
        Create Account
      </button>
    </div>
  </div>
</template>


<script>
import { serverAddr } from "@/networkConfig";
import NavBar from "@/components/NavBar.vue";


export default {
  components: {
    NavBar,
  },
  data() {
    return {
      isSubmitting: false,
      showPassword: false,
      form: {
        email_id: "",
        password: "",
        broker_id: "",
        full_name: "",
        mobile: "",
        role: ""
      },
      brokerList: []

    };
  },
  mounted() {
    this.getBrokerList();
  },
  methods: {
    onMobileInput(e) {
      let value = e.target.value.replace(/\D/g, "");
      if (value.length > 10) {
        value = value.slice(0, 10);
      }
      this.form.mobile = value;
    },
    getBrokerList() {
      serverAddr
        .get("/auth/admin/open_api/broker_list")
        .then((response) => {
          if (response.data.status) {
            this.brokerList = response.data.data;
          }
        })
        .catch(
          function (error) {
            console.log(error);
            this.is_user_list_loading = false;
          }.bind(this)
        );
    },

    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },

    createBrokerAdmin() {
      // Required field validation
      if (
        !this.form.full_name ||
        !this.form.email_id ||
        !this.form.mobile ||
        !this.form.password ||
        !this.form.broker_id ||
        !this.form.role
      ) {
        this.$message && this.$message.error("All fields are required");
        return;
      }

      this.isSubmitting = true;

      var payload = {
        email_id: this.form.email_id,
        password: this.form.password,
        broker_id: this.form.broker_id,
        full_name: this.form.full_name,
        mobile: this.form.mobile,
        user_role: this.form.role
      };

      serverAddr
        .post("/auth/admin/v1/create_broker_admin_account", payload)
        .then((response) => {
          console.log(response);

          if (response.data.status) {
            console.log(response.data.profile_data);

            this.$message &&
              this.$message.success(`${response.data.validation}`);
            // this.$router.push("/");
          }
        })
        .catch((error) => {
          console.log("Signup error:", error);
          this.$message &&
            this.$message.error(
              (error &&
                error.response &&
                error.response.data &&
                error.response.data.message) ||
              "Something went wrong"
            );
        })
        .finally(() => {
          this.isSubmitting = false;
          this.clearFormData()
        });
    },
    clearFormData() {
      this.form = {
        email_id: "",
        password: "",
        broker_id: "",
        full_name: "",
        mobile: "",
        role: ""
      }
    }
  },
};

</script>
<style scoped lang="scss">
.sign-up-container {
  background-image: url("../assets/background.png");
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  font-family: sans-serif, montserrat;

  .sign-up-form {
    padding: 0 20px 20px 20px;
    width: 300px;
    text-align: center;
    color: #777;
  }

  .logo {
    width: 180px;
    height: auto;
  }

  .signin-heading {
    font-size: 17px;
    height: 22px;
    color: #000;
    letter-spacing: 2px;
    font-weight: 600;
    margin: 30px 0;
  }

  .input-group {
    margin-bottom: 15px;
    text-align: left;
  }

  label {
    display: block;
    font-size: smaller;
    font-weight: bolder;
    margin-bottom: 5px;
    margin-left: 7px;
    color: rgb(11, 10, 10);
  }

  input[type="email"],
  input[type="text"],
  input[type="tel"],
  input[type="password"] {
    width: 90%;
    padding: 2px;
    border-bottom: 2px solid #777;
    outline: none;
    border-left: 0px;
    border-right: 0px;
    border-top: 0px;
    align-items: center;
    margin-left: 7px;
    margin-bottom: 5px;
    background: transparent;
  }

  .password-input {
    width: 90%;
    padding: 2px;
    border-bottom: 2px solid #777;
    outline: none;
    border-left: 0px;
    border-right: 0px;
    border-top: 0px;
    align-items: center;
    margin-left: 7px;
    margin-bottom: 5px;
  }

  .forgot-password {
    display: block;
    margin-top: 20px;
    text-decoration: none;
    color: #777;
    font-size: small;
    font-weight: lighter;
  }

  .password-visibility {
    position: absolute;
    right: 10px;
    top: 15px;
    z-index: 1;
    width: 20px;
  }

  .input-group {
    margin-bottom: 20px;
  }

  .input-group label {
    display: block;
    margin-bottom: 0px;
  }

  .password-input:focus {
    outline: none;
    border-bottom: 2px solid #000;
  }

  .password-visibility {
    position: absolute;
    right: 25px;
    top: 65%;
    transform: translateY(-50%);
    cursor: pointer;
    width: 20px;
    height: 20px;
  }

  .signin-button {
    display: block;
    width: 100%;
    padding: 10px;
    background-color: rgb(51, 69, 141);
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 25px;
  }

  .signin-button[disabled] {
    background-color: #ccc;
    cursor: not-allowed;
  }

  select {
    width: 90%;
    padding: 4px;
    border-bottom: 2px solid #777;
    border-left: 0;
    border-right: 0;
    border-top: 0;
    outline: none;
    margin-left: 7px;
    background: transparent;
    padding-left: 0;
    position: relative;
    z-index: 10;
  }
}
</style>

<!-- <style></style> -->
